/* BRB Again theme – small, dependency-free enhancements */
(function () {
  'use strict';

  /* Header: only one popover open at a time, close on Escape / outside click */
  var panels = document.querySelectorAll('details.hmenu, details.hsearch');
  panels.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      panels.forEach(function (o) { if (o !== d) o.open = false; });
      var input = d.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') panels.forEach(function (d) { d.open = false; });
  });
  document.addEventListener('click', function (e) {
    panels.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap.querySelector('input');
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart: update when a quantity changes */
  var cartForm = document.getElementById('cart-form');
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (e.target.matches('input[name="updates[]"]')) cartForm.submit();
    });
  }

  /* Collection / search filters: submit when a control changes */
  var filterForm = document.getElementById('filters-form');
  if (filterForm) {
    filterForm.addEventListener('change', function () { filterForm.submit(); });
    var box = filterForm.querySelector('.filters-box');
    if (box) {
      var desktop = window.matchMedia('(min-width: 990px)');
      var sync = function () {
        var active = box.querySelector('input:checked, .price-inputs input[value]:not([value=""])');
        box.open = desktop.matches || !!active;
      };
      sync();
      if (desktop.addEventListener) desktop.addEventListener('change', sync);
    }
  }

  /* Product form: variant selection */
  var productRoot = document.querySelector('[data-product]');
  if (productRoot) {
    var dataEl = productRoot.querySelector('[data-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = productRoot.querySelector('form[data-product-form]');
    var select = form.querySelector('select[name="id"]');
    var priceEl = productRoot.querySelector('[data-price]');
    var submit = form.querySelector('[data-submit]');
    var fieldsets = form.querySelectorAll('fieldset.opt');
    var labels = {
      add: submit ? submit.getAttribute('data-label-add') : 'Add to cart',
      sold: submit ? submit.getAttribute('data-label-sold') : 'Sold out',
      unavailable: submit ? submit.getAttribute('data-label-unavailable') : 'Unavailable'
    };

    var selected = function () {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    };

    var match = function (opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    };

    var markAvailability = function () {
      var current = selected();
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = current.slice();
          test[idx] = input.value;
          var v = match(test);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };

    var update = function () {
      var opts = selected();
      var v = match(opts);
      fieldsets.forEach(function (fs, i) {
        var out = fs.querySelector('[data-selected-value]');
        if (out) out.textContent = opts[i] || '';
      });
      if (!v) {
        submit.disabled = true;
        submit.textContent = labels.unavailable;
        return;
      }
      select.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      submit.disabled = !v.available;
      submit.textContent = v.available ? labels.add : labels.sold;
      markAvailability();
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.media_id) {
        var fig = productRoot.querySelector('[data-media-id="' + v.media_id + '"]');
        var gal = fig && fig.parentElement;
        if (fig && gal) {
          if (gal.scrollWidth > gal.clientWidth + 4) {
            gal.scrollTo({ left: fig.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
          } else if (window.innerWidth >= 900) {
            fig.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
    };

    form.addEventListener('change', function (e) {
      if (e.target.matches('.opt input')) update();
    });
    markAvailability();
  }

  /* Shop by type (fallback when Shopify's Product type filter is not enabled) */
  var pillWrap = document.querySelector('[data-type-pills]');
  if (pillWrap) {
    var grid = document.querySelector('[data-product-grid]');
    var count = document.querySelector('[data-count]');
    var items = grid ? Array.prototype.slice.call(grid.querySelectorAll('li[data-type]')) : [];
    var apply = function (type) {
      var shown = 0;
      items.forEach(function (li) {
        var ok = !type || li.getAttribute('data-type') === type;
        li.hidden = !ok;
        if (ok) shown++;
      });
      pillWrap.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-type-value') === type));
      });
      if (count) count.textContent = shown + (shown === 1 ? ' product' : ' products');
    };
    pillWrap.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-type-value]');
      if (b) apply(b.getAttribute('data-type-value'));
    });
    var wanted = new URL(window.location.href).searchParams.get('filter.p.product_type');
    if (wanted) apply(wanted);
  }
})();
